<template>
  <v-container fluid class="pt-0 pb-2">
    <v-row justify="space-around" align="center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon :color="color" v-on="on"
            @click="$emit('dialpad-toggle')" :disabled="isCalling">
            <v-icon>mdi-dialpad</v-icon>
          </v-btn>
        </template>
        <span>{{$t('sipua.menu.dialpad')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon :color="color"
            v-on="on" :disabled="isCalling"
            @click="$emit('voicemail')">
            <v-badge :value="sipuaVmNum > 0">
              <span slot="badge">{{sipuaVmNum}}</span>
              <v-icon>mdi-email-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>{{$t('sipua.menu.vmail')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="show-contacts" text icon :disabled="isCalling"
            :color="color" v-on="on" @click="$emit('show-contacts')">
            <v-icon>mdi-contacts</v-icon>
          </v-btn>
        </template>
        <span>{{$t('contacts.menuTitle')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="show-calls-log" text icon :disabled="isCalling"
            :color="color" v-on="on" @click="$emit('show-calls-log')">
            <v-badge :value="showMissedCalls && missedCalls > 0" color="orange">
              <span slot="badge">{{missedCalls}}</span>
              <v-icon>mdi-history</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>{{$t('sipua.menu.callsLog')}}</span>
      </v-tooltip>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'phone-app-menu',
  data () {
    return {
      color: 'primary'
    }
  },
  props: {
    isCalling: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      sipuaVmNum: 'sipuaVmNum',
      missedCalls: 'missedCalls',
      showMissedCalls: 'settings/showMissedCalls'
    })
  }
}
</script>

<style scoped>
</style>
